import React from 'react';

import SimpleCard from '../../../../components/Card/SimpleCard';
import UsageTrend from './UsageTrend';
import UsageTransitions from './UsageTransitions';
import SegmentConcentration from './SegmentConcentration';

const MarketBehavior = () => (
  <SimpleCard
    headerLeft={
      <>
        <h3 className="h3 header-heading">AI User Segmentation</h3>
        <p className="header-description">
          Identifies key AI user types and tracks the flow of these users.
        </p>
      </>
    }
    actionsLeft={<div className="highcharts-watermark" />}
    contentDisableGutters
  >
    <UsageTrend />
    <UsageTransitions />
    <SegmentConcentration />
  </SimpleCard>
);

export default MarketBehavior;
